import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        blackList: {
            apiPath: '/loader/black-list',
            properties: {
                id: {
                    type: 'number.integer',
                    displayName: 'ID',
                },
                skuCode: {
                    type: 'string',
                    displayName: 'SKU编码',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                salePrice: {
                    type: 'number.row',
                    displayName: '价格',
                },
            },
            filters: {
                skuCode: {
                    type: 'string',
                    displayName: 'SKU编码',
                    controlConfig: {
                        placeholder: 'SKU编码',
                    },
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                    controlConfig: {
                        placeholder: '商品名称',
                    },
                },
            },
        },
    },
    components: {
        blackListView: {
            component: 'Card',
            entity: 'blackList',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'blackListFilter',
                    },
                    {
                        component: 'BlackListTable',
                    },
                ],
            },
        },

        blackListFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'skuCode',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/black-list',
                            component: 'blackListView',
                            breadcrumbName: '商品黑名单',
                        },
                    ],
                },
            ],
        },
    ],
};
